import { Paper, Stack, TextField } from '@mui/material';

type TemplateNameEditorProps = {
    value?: string;
    onChange?: (val: string) => void;
};

export const TemplateNameEditor = ({
    onChange = () => undefined,
    value = '',
}: TemplateNameEditorProps): JSX.Element | null => {
    return (
        <Paper
            sx={{
                position: 'absolute',
                left: 48,
                top: 40,
                p: 1,
                minWidth: 300,
                boxShadow:
                    '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
            }}
            component={Stack}
        >
            <TextField
                placeholder="Название шаблона"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                size="small"
            />
        </Paper>
    );
};
